import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {Observable, of} from "rxjs";
import {catchError, debounceTime, map, startWith, switchMap} from "rxjs/operators";


@Component({
    selector: 'create-cash-report-item-dialog',
    templateUrl: './createCashReportItemDialog.component.html',
    styleUrls: ['./createCashReportItemDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class CreateCashReportItemDialogComponent {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    form: FormGroup;
    income: boolean = false;

    /**
     *
     * @param matDialogRef
     * @param _data
     * @param translationLoader
     * @param translate
     * @param _matDialog
     */
    constructor(
        public matDialogRef: MatDialogRef<CreateCashReportItemDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
        private _formBuilder: FormBuilder,
    ) {
        this.translationLoader.loadTranslations(polish);
        this.income = _data.income;

        if (_data.income) {
            this.form = this.createIncomeForm();
        } else {
            this.form = this.createOutcomeForm();
        }
    }

    createIncomeForm(): FormGroup {
        return this._formBuilder.group({
            proof: ['', Validators.required],
            income: ['', Validators.required],
            description: ['', Validators.required],
        });
    }

    createOutcomeForm(): FormGroup {
        return this._formBuilder.group({
            proof: ['', Validators.required],
            outcome: ['', Validators.required],
            description: [''],
        });
    }
}
